import { connect } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';

interface FavoritesDriveItemListPageProps extends AbstractDriveItemListPageProps {
	favorites: number[];
}

export class FavoritesDriveItemListPage extends AbstractDriveItemListPage<FavoritesDriveItemListPageProps> {

	headerLabel = 'messages.favorites';
	noItemsLabel = 'messages.no_favorites';
	hasShareButton = true;
	hasDownloadButton = true;
	hasPageTitle = true;

	initializeView(props: FavoritesDriveItemListPageProps): void {
		return;
	}

	getDriveItemIds(): number[] {
		return this.props.favorites;
	}
}

const mapStateToProps = (state: StoreState) => {
	const { favorites } = state;
	return { favorites };
};

export default connect(mapStateToProps)(FavoritesDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/Favorites.tsx